import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Card } from "shared/components/Card";
import { DatePicker } from "shared/components/DatePickerCalendar";

export const MoveInDateSlice = ({
  applicationId,
  onSuccess,
  moveInDate
}: {
  applicationId: number;
  onSuccess?: () => void;
  moveInDate?: string | null | undefined;
}) => {
  const [selectedDate, setSelectedDate] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (moveInDate) setSelectedDate(moveInDate);
  }, [moveInDate]);

  const { mutate: updateDesiredMoveInDate } = useMutation({
    mutationKey: ["APPLICATION_DESIRED_MOVE_IN"],
    mutationFn: (desiredMoveInDate: string) =>
      instance.patch(`/portal/v1/applications/${applicationId}`, {
        desired_move_in_date: desiredMoveInDate
      }),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(error.message || "Error");
    }
  });
  return (
    <div className="bg-background-900">
      <form
        className="max-w-[400px] mx-auto h-[calc(80vh-74px)] pt-6"
        onSubmit={(e) => {
          e.preventDefault();
          updateDesiredMoveInDate(selectedDate || "");
        }}
      >
        {/* <DateInput
          id="desired_move_in_date"
          label="Desired move-in date"
          name="desired_move_in_date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          required
          className="w-full"
        /> */}
        <Card>
          <DatePicker
            selectedDate={selectedDate}
            onSelectDate={(e) => {
              setSelectedDate(e);
            }}
          />
        </Card>

        <div className="mt-4">
          <Button
            className="w-full mt-auto"
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            type="submit"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};
